const INVEST_FOR_GOAL_LANDING = {
  dataAid: "investForGoal",
  title: "Invest for a goal",
};

export default INVEST_FOR_GOAL_LANDING;
